import { useState, useEffect } from 'react';
import axios from 'axios';

import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';

import './Lunar.scss';

const Lunar = () => {
  const [year, setYear] = useState(2025);
  const [lunarEclipses, setLunarEclipses] = useState([]);

  // Fetch lunar eclipses for given year
  useEffect(() => {
    axios
      .get(`https://core-c343.onrender.com/api/eclipes?year=${year}`)
      .then((res) => {
        const lunarOnly = res.data.months.filter((e) =>
          e.eclipseType.toLowerCase().includes("lunar")
        );
        setLunarEclipses(lunarOnly);
      })
      .catch((err) => {
        console.error("Error fetching eclipse data:", err);
      });
  }, [year]);

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  return (
    <div className="Lunar-container">
      <InnerNav />
      <div className="Lunar-content">
        <Zodiac />

        <div className="Lunar-details">
          <div className="title">{year} Lunar Eclipse Dates</div>

          {/* Year controls */}
          <div className="lunar-controls">
                <input
                  type="number"
                  value={year}
                  onChange={handleYearInput}
                />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>
                  Current Year
                </button>
                <button onClick={() => changeYear(1)}>Next Year</button>
              </div>

          {/* Eclipse list */}
          <div className="muhurta-section">
            {lunarEclipses.length === 0 ? (
              <p>No Lunar Eclipse data available for this year.</p>
            ) : (
              lunarEclipses.map((entry, index) => (
                <div className="rahu-card" key={index}>
                  <div className="rahu-header">
                    <h3>{entry.description}</h3>
                    <p>
                      {entry.date} ({entry.weekday})
                    </p>
                  </div>
                  <div className="rahu-img">
                    <img
                    src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ75zGwNziN2gQWnfpQwhro7lM5qO2HZzedIA&s'
                      alt="lunar"
                    />
                  </div>
                  <div className="rahu-data">
                    <h4>{entry.astronomicalEvent}</h4>
                    <p>{entry.visibilityNote}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <PlanetLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Lunar;
